import { render, staticRenderFns } from "./BriqueGrid.vue?vue&type=template&id=3c5e3008&"
import script from "./BriqueGrid.js?vue&type=script&lang=js&"
export * from "./BriqueGrid.js?vue&type=script&lang=js&"
import style0 from "./BriqueGrid.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports